import React, { Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux"; 
import routes from "./routes";
import logo from "./assets/techriya_logo_mod.png"
function App() {
  
  const token = useSelector((state) => state.Auth);
  
  return (
    <Suspense fallback={   <div className="bg-[#131313] h-screen flex justify-center items-center w-full ">
      <img src={logo} className="w-[6rem] animate-wiggle" alt="" />
     {/* <p className="text-white animate-wiggle">Loading...</p> */}
  </div>}>
      <Routes>
        {routes.map((route, index) => {
          if (route.private && !token) {
            return <Route key={index} path={route.path} element={<Navigate to="/login" />} />;
          }

          return <Route key={index} path={route.path} element={route.element} />;
        })}

        {token ? (
          <Route path="/" element={<Navigate to="/home" />} />
        ) : (
          <Route path="/" element={<Navigate to="/login" />} />
        )}
      </Routes>
    </Suspense>
  );
}

export default App;
